import { component } from "vue/types/umd";

const baseUrl = "/master-data";

export default [
  {
    path: baseUrl + "/outlets",
    name: "POSOutlet",
    component: () => import("@/pages/master-data/pos/outlets/Index.vue")
  },
  {
    name: "GeneralSetup",
    path: baseUrl + "/general-setup",
    component: () => import("@/pages/master-data/pos/general-setup/Index.vue")
  },
  {
    name: "Parameter",
    path: baseUrl + "/parameter",
    component: () => import("@/pages/master-data/pos/parameter/Index.vue")
  },
  {
    name: "IntercompanyMapping",
    path: baseUrl + "/intercompany-mapping",
    component: () => import("@/pages/master-data/pos/intercompany-mapping/Index.vue")
  },
  {
    path: baseUrl + "/table",
    name: "POSTable",
    component: () => import("@/pages/master-data/pos/tables/Index.vue")
  },
  {
    path: baseUrl + "/articles-product-types",
    name: "POSTableArticleProductTypes",
    component: () => import("@/pages/master-data/pos/articles-product-types/Index.vue")
  },
  {
    path: baseUrl + "/articles",
    name: "POSTableArticle",
    component: () => import("@/pages/master-data/pos/articles/Index.vue")
  },
  {
    path: baseUrl + "/articles-groups",
    name: "POSArticlesGroups",
    component: () => import("@/pages/master-data/pos/articles-groups/Index.vue")
  },
  {
    path: baseUrl + "/articles-groups-articles",
    name: "POSArticlesArticleGroups",
    component: () => import("@/pages/master-data/pos/articles-article-groups/Index.vue")
  },
  {
    path: baseUrl + "/article-group-outlets",
    name: "POSArticleGroupOutlet",
    component: () => import("@/pages/master-data/pos/article-group-outlet/Index.vue")
  },
  {
    name: "POSArticleFlavour",
    path: baseUrl + "/article-flavour",
    component: () => import("@/pages/master-data/pos/article-flavour/Index.vue")
  },
  {
    name: "POSArticleFlavourGroup",
    path: baseUrl + "/article-flavour-group",
    component: () => import("@/pages/master-data/pos/article-flavour-group/Index.vue")
  },
  {
    name: "POSArticleFlavourGroupArticleGroupSetup",
    path: baseUrl + "/article-flavour-article-group",
    component: () => import("@/pages/master-data/pos/article-flavour-group-article-group/Index.vue")
  },
  {
    path: baseUrl + "/collection-categories",
    name: "POSCollectionCategories",
    component: () => import("@/pages/master-data/pos/collection-categories/Index.vue")
  },
  {
    path: baseUrl + "/collection-types",
    name: "POSCollectionType",
    component: () => import("@/pages/master-data/pos/collection-types/Index.vue")
  },
  {
    path: baseUrl + "/collection-type-outlets",
    name: "POSCollectionTypeToOutlet",
    component: () => import("@/pages/master-data/pos/collection-type-outlets/Index.vue")
  },
  {
    path: baseUrl + "/collection-identification-group",
    name: "POSCollectionIdentificationGroup",
    component: () => import("@/pages/master-data/pos/collection-identification-group/Index.vue")
  },

  {
    path: baseUrl + "/collection-identification",
    name: "POSCollectionIdentification",
    component: () => import("@/pages/master-data/pos/collection-identification/Index.vue")
  },
  {
    path: baseUrl + "/prices",
    name: "POSPrice",
    component: () => import("@/pages/master-data/pos/prices/Index.vue")
  },
  {
    path: baseUrl + "/meal-time-setup",
    name: "MealTimeSetup",
    component: () => import("@/pages/master-data/pos/meal-time-setup/Index.vue")
  },
  {
    name: "POSDiscount",
    path: baseUrl + "/discount",
    component: () => import("@/pages/master-data/pos/discount/Index.vue")
  },
  {
    name: "POSCourseStage",
    path: baseUrl + "/course-stage",
    component: () => import("@/pages/master-data/pos/course-stage/Index.vue")
  },
  {
    name: "POSWaiter",
    path: baseUrl + "/waiter",
    component: () => import("@/pages/master-data/pos/waiter/Index.vue")
  },
  {
    name: "Printer Type",
    path: baseUrl + "/printer-type",
    component: () => import("@/pages/master-data/pos/printer-type/Index.vue")
  },
  {
    name: "Printer",
    path: baseUrl + "/printer",
    component: () => import("@/pages/master-data/pos/printer/Index.vue")
  },
  {
    name: "Screen",
    path: baseUrl + "/screen",
    component: () => import("@/pages/master-data/pos/screen/Index.vue")
  },
  {
    name: "Guest Profiles",
    path: baseUrl + "/guest-profiles",
    component: () => import("@/pages/master-data/guest-profile/view/GuestProfileList.vue")
  },
  {
    path: baseUrl + "/package",
    name: "POSTablePackage",
    component: () => import("@/pages/master-data/pos/package/Index.vue"),
  },
];
